import React from 'react';
import { BoxWrapper, GridWrapper } from './GridFormatter';
import LinkFormatter from './LinkFormatter';

/**
 * @param {Object} props
 * @param {Array<Object>} descriptions
 * @param {string} [descriptions[].title]
 * @param {Array<*>} [descriptions[].links] - See LinkFormatter.jsx
 */
export default function LinkGrid({ descriptions }) {
  return (
    <BoxWrapper>
      {descriptions.map(({ title, links }) => (
        <GridWrapper size={6} title={title} key={title}>
          <LinkFormatter links={links} />
        </GridWrapper>
      ))}
    </BoxWrapper>
  );
}
